<template>
  <div class="container">
    <!-- <el-form ref="searchForm" :model="searchData" inline>
      <el-form-item label="UID">
        <el-input v-model.number="searchData.user_id" size="mini" />
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="handleSearch">
            查找
        </el-button>
      </el-form-item>
    </el-form> -->

    <div class="head">
      <el-button type="primary" @click="handleAdd" size="small">添加成员</el-button>
    </div>

    <el-table
      :data="data"
    >
      <el-table-column
        prop="id"
        label="ID"
      />

      <el-table-column
        prop="name"
        label="名称"
      />

      <el-table-column
        prop="admin_id"
        label="admin UID"
      />

      <el-table-column
        prop="roles"
        label="角色"
      >
        <template slot-scope="scope">
          <el-tag
            :key="tag"
            v-for="tag in scope.row.roles"
            :disable-transitions="false">
            {{ getRoleName(tag) }}
          </el-tag>

        </template>
      </el-table-column>

      <el-table-column
        prop="team"
        label="团队"
      />

      <el-table-column
        prop="dd_url"
        label="钉钉群"
      />

      <el-table-column
        prop="wc_code"
        label="微信二维码"
      />

      <el-table-column
        prop="mp_code"
        label="公众号"
      />

      <el-table-column
        prop="status"
        label="状态"
        :formatter="(_, _1, v) => { return getStatusName(v) }"
      />

      <el-table-column
        label="操作"
      >
        <template slot-scope="scope">
          <el-button-group v-if="getStatusButton(scope.row.status)">
            <el-button size='mini' type="primary" @click="handleSetRole(scope.row)"> 分配角色 </el-button>
            <el-button v-if="!scope.row.team" size='mini' type="primary" @click="handleSetTeam(scope.row)"> 分配团队 </el-button>
            <el-button v-else size='mini' type="danger" @click="handleQuit(scope.row)"> 退出团队 </el-button>
            <el-button v-if="getStatusButton(scope.row.status)" size='mini' type="danger" @click="handleDisable(scope.row)"> 禁 用 </el-button>
            <el-button size='mini' type="warning" @click="handleEdit(scope.row)"> 修 改 </el-button>
          </el-button-group>
          <!-- <el-button v-if="!getStatusButton(scope.row.status)" size='mini' type="primary" @click="handleEnable(scope.row)"> 启用 </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <pager
      ref="pager"
      api="member_list"
      :filter="filter"
      :sort="sort"
      model="cs"
      @data-changed="onDataChanged"
    />

    <el-dialog 
      :title="this.editForm.id ? '编辑成员' : '新增成员'"
      :visible.sync="showEditForm"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleEditFormDialogClose"
    >

      <el-form ref="editForm" :model="editForm" :rules="editRules" label-position="right">
        
        <el-form-item prop="name" label="名称:" label-width="150px">
          <el-input v-model="editForm.name" style="width:50%" :disabled="isEdit()" />
        </el-form-item>

        <el-form-item v-if="!isEdit()" prop="username" label="管理员姓名:" label-width="150px" >
          <el-input v-model="editForm.username" style="width:50%" />
        </el-form-item>

        <el-form-item prop="dd_url" label="钉钉Url:" label-width="150px">
          <el-input v-model="editForm.dd_url" style="width:50%" />
        </el-form-item>

        <el-form-item prop="wc_code" label="微信二维码:" label-width="150px">
          <el-input v-model="editForm.wc_code" style="width:50%" :disabled="isEdit()"/>
        </el-form-item>

        <el-form-item prop="mp_code" label="公众号:" label-width="150px">
          <el-input v-model="editForm.mp_code" style="width:50%" :disabled="isEdit()"/>
        </el-form-item>

      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditForm = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveAdd">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog 
      title="设置角色"
      :visible.sync="showSetRoleForm"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleSetRoleFormDialogClose"
    >

      <el-form ref="setRoleForm" :model="setRoleForm" :rules="setRoleRules" label-position="right">
        
        <el-form-item prop="role" label="角色:" label-width="150px">
            <el-select v-model="setRoleForm.role" size="mini" multiple>
                <el-option
                    v-for="(itme, index) in roleList"
                    :key="index"
                    :label="itme.name"
                    :value="itme.key"
                />
            </el-select>
        </el-form-item>

      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetRoleForm = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveSetRole">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog 
      title="设置团队"
      :visible.sync="showSetTeamForm"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleSetTeamFormDialogClose"
    >

      <el-form ref="setTeamForm" :model="setTeamForm" :rules="setTeamRules" label-position="right">
        
        <el-form-item prop="team" label="团队ID:" label-width="150px">
          <el-select v-model="setTeamForm.team" label="团队ID">
            <el-option
              v-for="item in teamList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetTeamForm = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveSetTeam">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import Pager from "../ui/Pager"
  import request from "@/api/request"

  const initForm = {
    id: null,
    name: null,
    username: null,
    wc_code: null,
    mp_code: null
  },
  isTrueUrl = (rule, value, callback) => {
    let reg = /(https?|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/
    if (value) {
      if (!reg.test(value)) {
        callback(new Error('请输入正确的链接'))
      } else {
        callback()
      }
    } else {
      callback()
    }
    
  },

  initRules = {
    name: [
      {
        required: true,
        message: "名称不能为空"
      }
    ],
    username: [
      {
        required: true,
        message: "管理员姓名不能为空"
      }
    ],
    wc_code: [
      {
        required: true,
        message: "微信二维码不能为空"
      }
    ],
    mp_code: [
      {
        required: true,
        message: "公众号二维码不能为空"
      }
    ],
    dd_url: [
      {
        validator: isTrueUrl, 
        trigger: "blur"
      },
    ]
  }

  export default {
    name: 'TameMember',
    components: { Pager },
    data () {
      return {
        searchData: {},
        teamList: [],
        data: [],
        filter: {},
        sort: [],
        roleList: [
          {key: 'community_operation', name: '社群运营'},
          {key: 'planning_consultant', name: '规划顾问'}
        ],
        editForm: { ...initForm },
        editRules: { ...initRules },
        showEditForm: false,
        setRoleForm: { id: null, role: null },
        setRoleRules: {
          role: [
            {
              required: true,
              message: "角色不能为空"
            }
          ]
        },
        showSetRoleForm: false,
        setTeamForm: { id: null, team: null },
        setTeamRules: {
          team: [
            {
              required: true,
              message: "团队Id不能为空"
            }
          ]
        },
        showSetTeamForm: false
      }
    },
    computed: {
      
    },
    created() {
      this.getTeamList()
    },
    methods: {
      onDataChanged: function (data) {
        this.data = data
      },
      handleSearch() {
        let filter = {}
        this.filter = filter
      },
      handleAdd() {
        this.editForm = { ...initForm }
        this.showEditForm = true
      },
      handleSaveAdd() {
        this.$refs.editForm.validate(async valid => {
          if (valid) {
            if (this.isEdit()) {
              if (this.editForm.dd_url) {
                const data = {}
                Object.keys(this.editForm).forEach(k => {
                  if (this.editForm[k]) {
                    data[k] = this.editForm[k]
                  }
                })
                await request.cs
                  .post("member_update", { id: this.editForm.id, data: { dd_url: this.editForm.dd_url }})
                  .then(() => {
                    this.$message.success("修改成功")
                  })
                this.$refs.pager.loadData()
              }
              this.showEditForm = false;
            } else {
              const data = {}
              Object.keys(this.editForm).forEach(k => {
                if (this.editForm[k]) {
                  data[k] = this.editForm[k]
                }
              })
              await request.cs
                .post("member_create", data)
                .then(() => {
                  this.$message.success("添加成功")
                })
              this.showEditForm = false;
              this.$refs.pager.loadData()
            }
          }
        })
      },
      handleSaveSetRole() {
        this.$refs.setRoleForm.validate(async valid => {
          if (valid) {
            this.$refs.setRoleForm.clearValidate()
            
            await request.cs
              .post("member_role_set", this.setRoleForm)
              .then(() => {
                this.$message.success("设置角色成功")
              })
            this.showSetRoleForm = false;
            this.$refs.pager.loadData()
          }
        })
      },
      handleSaveSetTeam() {
        this.$refs.setTeamForm.validate(async valid => {
          if (valid) {
            this.$refs.setTeamForm.clearValidate()
            
            await request.cs
              .post("member_team_join", this.setTeamForm)
              .then(response => {
                if (response.data.ret) {
                  this.$message.success("加入团队成功")
                } else {
                  this.$message.error("加入团队失败")
                }
              })
            this.showSetTeamForm = false;
            this.$refs.pager.loadData()
          }
        })
      },
      handleEnable(row) {
        this.$confirm(`确定启用 ID 为 ${row.id} 的成员`)
          .then(() => {
            this.updateStatus(row.id, 0)
          })
      },
      handleDisable(row) {
        this.$confirm(`确定禁用 ID 为 ${row.id} 的成员`)
          .then(() => {
            this.updateStatus(row.id, 900)
          })
      },
      handleQuit(row) {
        this.$confirm(`确定把 ID 为 ${row.id} 的成员踢出团队`)
          .then(() => {
            this.memberQuit(row.id, 900)
          })
      },
      handleSetTeam(row) {
        this.setTeamForm.id = row.id
        this.setTeamForm.team = row.team
        this.showSetTeamForm = true
      },
      handleSetRole(row) {
        this.setRoleForm.id = row.id
        this.setRoleForm.role = row.role ? row.role : []
        this.showSetRoleForm = true
      },
      handlerSort(column) {
        this.sort = [
          {
            field: column.prop,
            reverse: column.order === 'descending'
          }
        ]
      },
      handleEdit(row) {
        this.editForm = { ...row }
        this.showEditForm = true
      },
      handleEditFormDialogClose() {
        this.editForm = { ...initForm }
        this.$refs.editForm.clearValidate()
      },
      handleSetRoleFormDialogClose() {
        this.$refs.setRoleForm.clearValidate()
      },
      handleSetTeamFormDialogClose() {
        this.$refs.setTeamForm.clearValidate()
      },
      updateStatus(id, status) {
        request
            .cs
            .post("member_status_update", {
                id: id,
                status: status
            }).then(() => {
                this.$message.success('操作成功')
                this.$refs.pager.loadData()
            }).catch(data => {
                this.$message.error(data.err)
            })

      },
      memberQuit(id) {
        request
            .cs
            .post("member_quit", {
                id: id
            }).then(() => {
                this.$message.success('操作成功')
                this.$refs.pager.loadData()
            }).catch(data => {
                this.$message.error(data.err)
            })

      },
      getRoleName(key) {
        return this.roleList.find(item => item.key === key).name
      },
      getStatusName(key) {
        return key === 0 ? '启用' : '禁用'
      },
      getStatusButton(key) {
        return key === 0
      },
      getTeamList() {
        request
            .cs
            .post("team_list", {
                range: [0, 200]
            }).then(response => {
              this.teamList = []
              if (response.data.list) {
                this.teamList = response.data.list.filter(item => item.status === 0)
              }
            })
      },
      isEdit() {
        return !!this.editForm.id
      }
    }
  }
</script>
